module.exports = __webpack_public_path__ + "static/img/Frame 2510@2x.0fc3478.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Frame 2510@2x.png
// module id = bsD3
// module chunks = 1